module.exports = __webpack_public_path__ + "a768e7de/img/document.e2130c6b.svg";